import { Component, EventEmitter, Output } from '@angular/core';
import { BaseChartComponent } from '../basechart/basechart.component';

@Component({
  selector: 'app-sunburst',
  templateUrl: '../basechart/basechart.component.html',
})
export class SunburstComponent extends BaseChartComponent<any[]> {
  @Output() newRootEvent = new EventEmitter<string>();

  draw(renderingId: string) {
    this.options = {
      title: {
        text: this.title,
      },
      plotOptions: {
        sunburst: {
          levels: [
            {
              level: 2,
              colorByPoint: true,
            },
            {
              level: 3,
              colorVariation: {
                key: 'brightness',
                to: -0.1
              }
            }
          ],
        },
      },
      series: [
        {
          type: 'sunburst',
          data: this.data,
          cursor: 'pointer',
          allowTraversingTree: true,
          breadcrumbs: {
            showFullPath: false,
            format: 'Go back',
          },
        },
      ]
    };
  }
}
